// extracted by mini-css-extract-plugin
export default {"errorContainer":"GraphqlError_errorContainer__4tJWk"};